import { render, staticRenderFns } from "./Acl.vue?vue&type=template&id=79f56036"
import script from "./Acl.vue?vue&type=script&lang=js"
export * from "./Acl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports